import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/recomCode.jpg';

const _withScopeId = n => (_pushScopeId("data-v-3e8ee95a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "recom-bottom-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "recom-content-img"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "recom-content-before"
}, "扫码立即参与，赚万元佣金！", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "recom-content-after"
}, "* 本活动解释权归三一集团所有", -1));

const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5);
}